import router from '../../router';

export function logout() {
    // 移除本地存储中的JWT
    localStorage.removeItem('jwt-token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    // 重定向到登录页面或者主页
    router.push('/login'); // 如果你在组件中使用这个函数，可以这样重定向
}


export function redirect_to(url) {
    window.location.href = url
}








// WEBPACK FOOTER //
// ./src/utils/plugin/index.js